import { TradeType } from 'app/console-api';

export interface DealTradeType {
  key: TradeType;
  name: string;
  icon: string;
  dealRequestDescription: string;
}

export const getDealInverseType = (type: TradeType): TradeType => {
  switch (type) {
    case 'buy':
      return 'sell';
    case 'sell':
      return 'buy';
  }
  return type;
};

export const DealTradeTypes: DealTradeType[] = [
  {
    key: 'exchange',
    name: 'Exchange',
    icon: 'mdi:exchange',
    dealRequestDescription: 'Partners exchange traffic based on selected offers from both sides.'
  },
  {
    key: 'buy',
    name: 'Buy',
    icon: 'f7:money-dollar',
    dealRequestDescription:
      'Buying traffic from partners based on selected offers. You pay for the traffic you receive.'
  },
  {
    key: 'sell',
    name: 'Sell',
    icon: 'f7:money-dollar',
    dealRequestDescription:
      'Selling traffic to partners based on selected offers. You get paid for the traffic you send.'
  },
  {
    key: 'internal',
    name: 'Internal',
    icon: 'f7:arrow-right-circle',
    dealRequestDescription: ''
  }
];
